// MUTATIONS
export const ADD_COUNTRY = 'pricing/ADD_COUNTRY'
export const HIDE_NOTIFICATION = 'pricing/HIDE_NOTIFICATION'
export const REMOVE_COUNTRY = 'pricing/REMOVE_COUNTRY'
export const SET_CUSTOM_FEE_VALUE = 'pricing/SET_CUSTOM_FEE_VALUE'
export const SET_EDIT_STATE = 'pricing/SET_EDIT_STATE'
export const SET_EDIT_MODE = 'pricing/SET_EDIT_MODE'
export const SET_FEE_VALUE = 'pricing/SET_FEE_VALUE'
export const SET_ACCOUNTS = 'pricing/SET_ACCOUNTS'
export const SET_LOADING = 'pricing/SET_LOADING'
export const SET_PRICING_FEES = 'pricing/PRICING_FEES'
export const SET_SELECTED_COUNTRY = 'pricing/SET_SELECTED_COUNTRY'
export const SET_SELECTED_PRODUCT = 'pricing/SET_SELECTED_PRODUCT'
export const STATE_MODIFIED = 'pricing/SET_MODIFIED'
export const SET_CUSTOM_FEE_DIALOG_OPTIONS =
  'pricing/SET_CUSTOM_FEE_DIALOG_OPTIONS'
export const SHOW_CUSTOM_FEE_DIALOG = 'pricing/SHOW_CUSTOM_FEE_DIALOG'
export const HIDE_CUSTOM_FEE_DIALOG = 'pricing/HIDE_CUSTOM_FEE_DIALOG'
export const ADD_CUSTOM_FEE = 'pricing/ADD_CUSTOM_FEE'
export const REMOVE_CUSTOM_FEE = 'pricing/REMOVE_CUSTOM_FEE'
export const SET_SUPPORTED_COUNTRIES = 'pricing/SET_SUPPORTED_COUNTRIES'

//GETTERS
export const GET_AVAILABLE_COUNTRIES = 'pricing/GET_AVAILABLE_COUNTRIES'

// ACTIONS
export const GET_PRICINGS = 'pricing/GET_INVOICES'
export const ROLL_CHANGES_BACK = 'pricing/ROLL_CHANGES_BACK'
export const UPDATE_AVAILABLE_COUNTRIES = 'pricing/UPDATE_AVAILABLE_COUNTRIES'
export const SAVE_CHANGES = 'pricing/SAVE_CHANGES'
export const GET_ACCOUNTS = 'pricing/GET_ACCOUNTS'
export const GET_SUPPORTED_COUNTRIES = 'pricing/GET_SUPPORTED_COUNTRIES'
